
import { supabase } from '@/integrations/supabase/client';
import { MenuItem } from '@/types/menu';
import { logActivityEvent } from '@/services/activity/activityLogService';

export const toggleAvailability = async (
  itemId: string,
  available: boolean
): Promise<boolean> => {
  try {
    // First fetch the current menu item to get its name and store_id
    const { data: currentItem, error: fetchError } = await supabase
      .from('menu_items')
      .select('*')
      .eq('id', itemId)
      .single();

    if (fetchError) {
      console.error("Error fetching menu item:", fetchError);
      throw fetchError;
    }

    if (!currentItem) {
      console.error("Menu item not found");
      return false;
    }

    // Update the item availability
    const { data: updatedItem, error: updateError } = await supabase
      .from('menu_items')
      .update({ available })
      .eq('id', itemId)
      .select()
      .single();

    if (updateError) {
      console.error("Error updating menu item availability:", updateError);
      throw updateError;
    }

    // Log activity
    await logActivityEvent({
      entity_type: 'menu_item',
      entity_id: itemId,
      user_name: 'Admin',
      action: available 
        ? 'menu_item_marked_available' 
        : 'menu_item_marked_unavailable',
      details: { 
        name: currentItem.name,
        price: currentItem.price
      },
      store_id: currentItem.store_id
    });

    return true;
  } catch (error) {
    console.error("Error toggling menu item availability:", error);
    return false;
  }
};
